import checkWindowFrame from "@/utils/checkWindowFrame";
import {compose, createStore} from "redux";

const defaultState = {
    form: {data: {}},
    formTemplate: '',
    formPrevTemplate: '',
    formSelectedPlace: [],
    idLesson: 0,
    modal: {
        open: false,
        title: '',
        content: '',
        handler: null,
        courseId: '',
        recaptcha: null,
        buttons: []
    },
    notice: {
        open: false,
        type: null,
        message: '',
        closingTime: null
    },
    notification: {
        open: false,
        type: null,
        title: '',
        message: ''
    },
    pagination: {
        "current-page": null,
        "from": null,
        "last-page": null,
        "per-page": null,
        "to": null,
        "total": null,
        "getLessonPaginator": function (val) {
            console.log(val)
        },
        "getUpdateLesson": null,
    },
    errorValidation: null,
    errorFields: null,
    errorSessions: null,
    percentProgress: 0,
    editorGroup: {
        name: "",
        color: "",
        type: "",
        id: ""
    },
    currentEvent: null,
    iframe: checkWindowFrame(),

    notificationForm: null,
    includedSessions: null,
    schedules: {
        session_id: null,
        date: null,
        time: null,
        dates: null,
        times: null,
        sessions: null,
        tickets: null,
        is_preview: false,
        from: null
    },

    newEvent: {
        event_title: {value: '', error: null},
        category_id: {value: 2, error: null},
        is_widget: {value: 0, error: null},
        is_online: {value: 0, error: null},
        event_city_name: {value: '', error: null},
        event_city_id: {value: '', error: null},
        event_address: {value: '', error: null},
        event_url: {value: '', error: null},
        dateless: {value: 0, error: null},
        timezone: {value: 'Europe/Moscow', error: null},
        datetime_start: {value: null, error: null},
        datetime_end: {value: null, error: null},
        company_title: {value: '', error: null},
        company_email: {value: '', error: null},
        company_phone: {value: '', error: null},
        a5000: {value: 0, error: null},
        oneDay: {value: 0, error: null},
        ownerProps: null,
        slug: {value: null, error: null},
    },
    ticketMember: {
        user: 0,
        place: []
    },
    //todo: проработать структуру приложения в панели управления, формы, лендинга и редактора по анологии ниже
    admin: {
        constants: {},
        event: {},
        events: [],
        profile: {},
    },
    widget: {order: null, bill: null, complete: null}
    //promo: {...}
    //editor: {...}
}

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_FORM_SELECTED_PLACE":
            return {...state, formSelectedPlace: action.payload}
        case "SET_FORM_TICKET_MEMBER":
            return {...state, ticketMember: action.payload}
        case "SET_FORM_TEMPLATE":
            return {...state, formTemplate: action.payload}
        case "SET_FORM_PREV_TEMPLATE":
            return {...state, formPrevTemplate: action.payload}
        case "SET_FORM_NOTIFICATION":
            return {...state, notificationForm: action.payload}
        case "SET_FORM":
            return {...state, form: action.payload}
        case "SET_PAGINATION":
            return {...state, pagination: action.payload}
        case "SET_ERROR_VALIDATION":
            return {...state, errorValidation: action.payload}
        case "SET_ERROR_FIELDS":
            return {...state, errorFields: action.payload}
        case "SET_ERROR_SESSIONS":
            return {...state, errorSessions: action.payload}
        case "SET_ID_LESSON":
            return {...state, idLesson: action.payload}
        case "GET_ID_LESSON":
            return state
        case "SET_MODAL":
            return {...state, modal: action.payload}
        case "SET_NOTICE":
            return {...state, notice: action.payload}
        case "SET_NOTIFICATION":
            return {...state, notification: action.payload}
        case "SET_PERCENT_UPLOAD_FILE":
            return {...state, percentProgress: action.payload}
        case "SET_EDITOR_GROUP":
            return {...state, editorGroup: action.payload}
        case "SET_ERROR":
            return {...state, error: action.payload}
        case "SET_CONTENT_TYPE_TEXT":
            return {...state, currentEvent: action.payload}
        case "SET_SCHEDULE_CURRENT":
            return {...state, schedules: action.payload}

        case "SET_ADMIN":
            return {...state, admin: action.payload}
        case "SET_NEW_EVENT":
            return {...state, newEvent: action.payload}
        default:
            return state
    }
}

const enhancers = compose(
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const store = createStore(
    reducer,
    defaultState,
    enhancers
);
